import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import CustomersDetails from "../../components/user/sales/CustomersDetails";
import ItemDetails from "../../components/user/sales/ItemDetails";
import { useSalesContext } from "../../context/sales_context";


function SalesPage() {


      const {
            type, changeType,
      } = useSalesContext();

      return (
            <>
                  <AppWrapper
                        pagename={"sales"}
                  >
                        <StyledSalesPage>

                              <Title
                                    title={"Record Sales"}
                                    btnName={"Invoice"}
                                    link={'/user/sales/invoice'}
                              />

                              {/* Select buttons for Services or Products */}

                              <div
                                    className="d-flex transparent py-2 px-2 br-sm fit-content mx-auto mt-4 justify-content-between pry-border">
                                    <div
                                          className={`col br-sm py-1 pry-bold-text pointer text-center px-3 ${ type === 'product' ? 'pry-bold light-text ' : ('') } `}
                                          onClick={e => changeType('product')}
                                    >
                                          Products
                                    </div>
                                    <div
                                          className={`col br-sm py-1 pry-bold-text pointer text-center px-3 ${ type === 'service' ? 'pry-bold light-text' : ('') } `}
                                          onClick={e => changeType('service')}
                                    >
                                          Services
                                    </div>
                              </div>

                              <div className="mt-3">

                                    <CustomersDetails />

                                    <ItemDetails />
                              </div>
                        </StyledSalesPage>



                  </AppWrapper>

            </>
      );
}

export default SalesPage;

const StyledSalesPage = styled.div`
  
.withSign {
  position: relative !important;
  bottom: 3.8rem !important;
  left: 0.5rem;
}


`;